import {PrintDocument} from "./print-document";
import {Registration} from "./registration";
import {Requirement} from "./requirement";
import { Ownership } from "./ownership";
import {Bot} from "./bot";

export class DocumentResult {
  public id: string;
  public fileId: string;
  public name: string;
  public sortOrder: number;
  public registrationId: string;
  public requirementId: string;
  public bot: Bot;
  public registration: Registration;
  public requirement: Requirement = new Requirement();
  public resultIsPhysical: boolean;
  public resultIsDigital: boolean;
  public multiple: boolean;
  public additionalInformation: string;
  public jsonDeterminants: string;
  public ownership: Ownership = new Ownership();
  public linkingFileUploadPath: string;
  public linkingFileUploadPathRouterLink: string;
}
